// Basic "local@domain.tld" check: requires an @ and a dot-separated TLD.
// Stricter than yup's built-in `.email()`, which accepts addresses without a TLD (e.g. "foo@bar").
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default class EmailHelper {
  static isValid(email: string): boolean {
    return EMAIL_REGEX.test(email);
  }
}
